import "./skeleton.css";

export interface SkeletonProps {
  variant?: "line" | "block" | "circle";
  width?: string | number;
  height?: string | number;
  /** Optional SR label. Defaults to "Завантаження вмісту". */
  label?: string;
}

export function Skeleton({
  variant = "line",
  width,
  height,
  label = "Завантаження вмісту",
}: SkeletonProps) {
  return (
    <span
      className={`wp-skeleton wp-skeleton--${variant}`}
      style={{
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
      }}
      role="status"
      aria-label={label}
    />
  );
}
